<template>
  <card>
    <vue-element-loading
      :active="loading.active"
      :color="loading.color"
      :is-full-screen="false"
      :text="loading.text"
      spinner="bar-fade-scale"/>
    <div slot="header">
      <h4 class="title">Nueva Opcion</h4>
    </div>
    <div>
      <form id="edit_form">
        <div class="row">
          <div class="col-md-6">
            <fg-input :error="getError('name')"
                      label="Nombre"
                      name="name"
                      placeholder="Nombre de la Opcion"
                      type="text"
                      v-model="device.options"
                      v-validate="modelValidations.name"
            >
            </fg-input>
          </div>
        </div>
        <div class="text-right">
          <button @click.prevent="validate" class="btn btn-filmker-pink btn-fill btn-sm" type="submit">
            Agregar Opcion
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
  import vueElementLoading from 'vue-element-loading'
  import swal from 'sweetalert2'
  import {Dialog, Option, Select} from 'element-ui'

  export default {
    components: {
      vueElementLoading,
      swal,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        users: [],
        loadingUsers: false,
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        device: {
          options: '',
        },
        account: {},
        modelValidations: {
          name: {
            required: true
          },
          country: {
            required: true,
          }
        }
      }
    },
    mounted() {
    },
    methods: {
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid)
            this.addDevice();
        })
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      addDevice() {
        this.loading.active = true
        this.axios({
          url: `conexions.php`,
          method: 'post',
          data: this.device,
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.showSwal('success', 'Opcion Creada')
            this.clearModel()
          })
          .catch(error => {
            console.log(error.response)
            this.loading.active = false
            this.showSwal('error', error.response.data.message)
          })
      },
      showSwal(type, message) {
        if (type === 'success') {
          swal.fire({
            title: message,
            type: 'success'
          })
        } else if (type === 'error') {
          swal.fire({
            title: message,
            type: 'warning'
          })
        }
      },
      clearModel() {
        this.device = {
          options: '',
        }
      }
    }
  }

</script>
<style>
  #edit_form label {
    color: #777 !important;
  }

  option {
    background-color: red !important;
  }
</style>
